<template>
  <a-modal title="详情" v-model="visible" :footer="null" width="800px">
    <div>
      <a-button @click="handleCheckBatchNo" type="danger">驳回</a-button>
      <a-button @click="handleCheckBatchOk" type="primary">通过</a-button>
    </div>
    <a-card title="基础信息">
      <div class="labelItem">
        <div>耳标号：</div>
        <div>{{model.tagsNumber}}</div>
      </div>
      <div class="labelItem">
        <div>毛色：</div>
        <div>{{model.coatColor}}</div>
      </div>
      <div class="labelItem">
        <div>月龄：</div>
        <div>{{model.monthOld}}</div>
      </div>
      <div class="labelItem">
        <div>品种：</div>
        <div>{{model.varietyName_dictText}}</div>
      </div>
      <div class="labelItem">
        <div>当前状态：</div>
        <div>{{model.statusing_dictText}}</div>
      </div>
<!--      <div class="labelItem">-->
<!--        <div>性别：</div>-->
<!--        <div>{{model.gender_dictText}}</div>-->
<!--      </div>-->
      <div class="labelItem">
        <div>所属养殖户：</div>
        <div>{{model.userId_dictText}}</div>
      </div>
      <div class="labelItem">
        <div>母牛信息：</div>
        <div>{{model.beefNumber}}</div>
        <a-button icon="search" type="primary" style="margin-left: 10px" size="small"
                  @click="seeDetail(model.beefNumber)">查看详情
        </a-button>
      </div>
      <div class="labelItem">
        <div>照片：</div>
        <div style="display: flex;flex-wrap: wrap;width: 80%;">
          <template v-for="item of model.photoList">
            <!--            <div style="width: 145px;height: auto;margin-left: 5px" @click="showPreView(item)">-->
            <!--              <img :src="item" style="width: 100%;height: 100%;">-->
            <!--            </div>-->
            <div style="width: 145px;height: auto;margin-left: 5px">
              <img :src="item" style="width: 100%;height: 100%;" :preview="item+new Date().getTime">
            </div>
          </template>
        </div>
      </div>
    </a-card>
    <a-card title="操作记录" style="margin-top: 10px;">
      <a-timeline v-for="item of checkRecordList">
        <a-timeline-item v-if="item.statusing=='1'">
          <div>{{item.createTime}}</div>
          <div
            style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
            v-if="item.user">
            <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
              <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
            </div>
            <div style="margin-left: 10px;">
              <div>
                {{item.user.realname}}
              </div>
              <div style="color: #777777">
                {{item.remark}}
              </div>
            </div>
            <div
              style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: orange;border-radius: 30px;color: #FFFFFF">
              待初审
            </div>
          </div>
        </a-timeline-item>
        <a-timeline-item v-if="item.statusing=='2'">
          <div>{{item.createTime}}</div>
          <div
            style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
            v-if="item.user">
            <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
              <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
            </div>
            <div style="margin-left: 10px;">
              <div>
                {{item.user.realname}}
              </div>
              <div style="color: #777777">
                {{item.remark}}
              </div>
            </div>
            <div
              style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: #44ff00;border-radius: 30px;color: #FFFFFF">
              初审通过
            </div>
          </div>
          <div style="margin-top: 10px">审核人</div>
          <div
            style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
            v-if="item.checkUser">
            <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
              <img :src="item.checkUser.avatar" style="width: 100%;height: 100%;"/>
            </div>
            <div style="margin-left: 10px;">
              <div>
                {{item.checkUser.realname}}
              </div>
              <div style="color: #777777" v-if="item.remark">
                {{item.remark}}
              </div>
            </div>
            <div style="margin-left: 10px;" v-if="item.towSignSrc">
              <div style="width: 100px;height: auto;overflow: hidden;">
                <img :src="item.towSignSrc" style="width: 100%;height: 100%;"/>
              </div>
            </div>
          </div>
        </a-timeline-item>
        <a-timeline-item v-if="item.statusing=='3'">
          <div>{{item.createTime}}</div>
          <div
            style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
            v-if="item.user">
            <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
              <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
            </div>
            <div style="margin-left: 10px;">
              <div>
                {{item.user.realname}}
              </div>
              <div style="color: #777777">
                {{item.remark}}
              </div>
            </div>
            <div
              style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: #00ffb7;border-radius: 30px;color: #FFFFFF">
              终审通过
            </div>
          </div>
          <div style="margin-top: 10px">审核人</div>
          <div
            style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
            v-if="item.checkUser">
            <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
              <img :src="item.checkUser.avatar" style="width: 100%;height: 100%;"/>
            </div>
            <div style="margin-left: 10px;">
              <div>
                {{item.checkUser.realname}}
              </div>
              <div style="color: #777777" v-if="item.remark">
                {{item.remark}}
              </div>
            </div>
            <div style="margin-left: 10px;" v-if="item.couSignSrc">
              <div style="width: 100px;height: auto;overflow: hidden;">
                <img :src="item.couSignSrc" style="width: 100%;height: 100%;"/>
              </div>
            </div>
          </div>
        </a-timeline-item>
        <a-timeline-item v-if="item.statusing=='5'">
          <div>{{item.createTime}}</div>
          <div
            style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
            v-if="item.user">
            <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
              <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
            </div>
            <div style="margin-left: 10px;">
              <div>
                {{item.user.realname}}
              </div>
              <div style="color: #777777">
                {{item.remark}}
              </div>
            </div>
            <div
              style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: red;border-radius: 30px;color: #FFFFFF">
              初审驳回
            </div>
          </div>
          <div style="margin-top: 10px">审核人</div>
          <div
            style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
            v-if="item.checkUser">
            <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
              <img :src="item.checkUser.avatar" style="width: 100%;height: 100%;"/>
            </div>
            <div style="margin-left: 10px;">
              <div>
                {{item.checkUser.realname}}
              </div>
              <div style="color: #777777" v-if="item.remark">
                驳回原因：{{item.remark}}
              </div>
            </div>
          </div>
        </a-timeline-item>
        <a-timeline-item v-if="item.statusing=='6'">
          <div>{{item.createTime}}</div>
          <div
            style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
            v-if="item.user">
            <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
              <img :src="item.user.avatar" style="width: 100%;height: 100%;"/>
            </div>
            <div style="margin-left: 10px;">
              <div>
                {{item.user.realname}}
              </div>
              <div style="color: #777777">
                {{item.remark}}
              </div>
            </div>
            <div
              style="position: absolute;right: 10px;top: 10px;padding: 0 10px;background-color: #950000;border-radius: 30px;color: #FFFFFF">
              终审驳回
            </div>
          </div>
          <div style="margin-top: 10px">审核人</div>
          <div
            style="background-color: #f5f5f5;width: 100%;border-radius: 10px;display: flex;padding: 10px;position: relative;color:#000;"
            v-if="item.checkUser">
            <div style="width: 30px;height: 30px;border-radius: 50%;overflow: hidden;">
              <img :src="item.checkUser.avatar" style="width: 100%;height: 100%;"/>
            </div>
            <div style="margin-left: 10px;">
              <div>
                {{item.checkUser.realname}}
              </div>
              <div style="color: #777777" v-if="item.remark">
                驳回原因：{{item.remark}}
              </div>
            </div>
          </div>
        </a-timeline-item>
      </a-timeline>
    </a-card>

    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false;">
      <img alt="example" style="width: 100%" :src="previewImage"/>
    </a-modal>
    <beef-cattle-detail-modal ref="detailChildModal"></beef-cattle-detail-modal>
  </a-modal>
</template>

<script>

  import { postAction, getAction } from '@/api/manage'
  import BeefCattleDetailModal from './BeefCattleDetailModal1'

  export default {
    components: { BeefCattleDetailModal },
    data() {
      return {
        model: {},
        validatorRules: {},
        url: {},
        visible: false,
        batchCheck: '/beef/beefCattle/batchCheck',
        list: '/beef/beefCattle/list',
        listBeefAll: '/beef/beefCheckRecord/listBeefAll',
        checkRecordList: [],
        previewVisible: false,
        previewImage: ''
      }
    },
    computed: {},
    created() {
    },
    methods: {
      handleCheckBatchNo() {
        this.checkPost('6')
      },
      handleCheckBatchOk() {
        this.checkPost('3')
      },
      checkPost(statusing) {
        let ids = []
        let checkStatus = this.userInfo && this.userInfo.userTypes == '3' ? '1' : '2'
        if (this.model.statusing) {
          if (checkStatus === this.model.statusing) {
            ids.push(this.model.id)
          }
        }
        if (ids.length == 0) {
          this.$message.warning('暂无待审核')
          this.visible = false
          this.visibleCheck = false
          this.loadingTag = false
          this.checkUserRows = []
          return
        }
        this.loadingTag = true
        postAction(this.url.batchCheck, { statusing, ids }).then(res => {
          if (res.success) {
            this.$message.success(res.message)
          } else {
            this.$message.warning(res.message)
          }
        }).finally(final => {
          this.visibleCheck = false
          this.loadingTag = false
          this.checkUserRows = []
          this.$emit('ok')
        })
      },
      seeDetail(tagsNumber) {
        getAction(this.list, { tagsNumber }).then(res => {
          if (res.result.records.length > 0) {
            this.$refs.detailChildModal.show(res.result.records[0])
          }
        })
      },
      showPreView(item) {
        this.previewVisible = true
        this.previewImage = item
      },
      checkList() {
        getAction(this.listBeefAll, { beefId: this.model.id }).then(res => {
          console.log(this.listBeefAll, res)
          this.checkRecordList = res.result
        })
      },
      show(record) {
        this.model = record
        if (this.model.photos) {
          this.model.photoList = this.model.photos.split(',')
        }
        this.visible = true
        this.checkList()
      }
    }
  }
</script>

<style>
  .labelItem {
    display: flex;
    color: black;
  }
</style>